import React, { useEffect, useState } from 'react';
import { useLanguage } from './LanguageContext';
import './LangToggle.css';

function LangToggle() {
  const { language, toggleLanguage } = useLanguage();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight * 0.5;
      setVisible(window.scrollY < heroHeight);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button className="lang-toggle" onClick={toggleLanguage}>
      {language === 'en' ? 'ES' : 'EN'}
    </button>
  );
}

export default LangToggle;